import React from 'react';
import { STYLES, getInputBorderColor, getValidationTextColor } from './styles.js';

/**
 * Componente reutilizable para campos UUID
 */
export const UuidInputField = ({ 
  id, 
  label, 
  placeholder, 
  value, 
  isValid, 
  onChange, 
  showValidation = true 
}) => {
  return (
    <div style={STYLES.inputField}>
      <label htmlFor={id} style={STYLES.label}>
        {label}
      </label>
      <input
        id={id}
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{
          ...STYLES.input,
          border: `2px solid ${getInputBorderColor(value, isValid)}`,
        }}
      />
      {showValidation && value.length > 0 && (
        <small style={{ 
          color: getValidationTextColor(isValid), 
          display: 'block' 
        }}>
          {isValid ? 'Formato UUID v4 válido' : 'Formato inválido'}
        </small>
      )}
    </div>
  );
};

/**
 * Componente para mostrar errores
 */
export const ErrorState = ({ error, onDismiss }) => (
  <div style={STYLES.errorContainer}>
    <strong>Error:</strong> {error}
    {onDismiss && (
      <button 
        onClick={onDismiss}
        style={{
          marginLeft: '10px',
          padding: '2px 6px',
          background: 'transparent',
          border: '1px solid currentColor',
          borderRadius: 2,
          color: 'inherit',
          cursor: 'pointer'
        }}
      >
        ×
      </button>
    )}
  </div>
);

/**
 * Componente para mostrar información
 */
export const InfoBox = ({ children }) => (
  <div style={STYLES.infoContainer}>
    {children}
  </div>
);
